import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { DiagnosticoSection } from '../components/DiagnosticoSection';
import { CostoInvisibleSection } from '../components/CostoInvisibleSection';
import { IdentidadSection } from '../components/IdentidadSection';
import { SolucionSection } from '../components/SolucionSection';
import { TestimoniosSection } from '../components/TestimoniosSection';
import { ObjecionesSection } from '../components/ObjecionesSection';
import { PrecioSection } from '../components/PrecioSection';
import { CierreSection } from '../components/CierreSection';
export function LandingPage() {
  return <main className="w-full bg-[#FFFFFF] font-sans" data-id="element-149">
      <HeroSection data-id="element-150" />
      <DiagnosticoSection data-id="element-151" />
      <CostoInvisibleSection data-id="element-152" />
      <IdentidadSection data-id="element-153" />
      <SolucionSection data-id="element-154" />
      <TestimoniosSection data-id="element-155" />
      <ObjecionesSection data-id="element-156" />
      <PrecioSection data-id="element-157" />
      <CierreSection data-id="element-158" />
    </main>;
}